
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21 2.20995C20.87 2.20995 20.74 2.25995 20.65 2.35995L19.86 3.14995C19.66 3.34995 19.35 3.34995 19.15 3.14995L18.36 2.35995C18.16 2.15995 17.85 2.15995 17.65 2.35995L16.86 3.14995C16.66 3.34995 16.35 3.34995 16.15 3.14995L15.36 2.35995C15.16 2.15995 14.85 2.15995 14.65 2.35995L13.86 3.14995C13.66 3.34995 13.35 3.34995 13.15 3.14995L12.36 2.35995C12.16 2.15995 11.85 2.15995 11.65 2.35995L10.86 3.14995C10.66 3.34995 10.35 3.34995 10.15 3.14995L9.35 2.34995C9.15 2.14995 8.84 2.14995 8.64 2.34995L7.85 3.14995C7.65 3.34995 7.34 3.34995 7.14 3.14995L6.35 2.34995C6.15 2.14995 5.84 2.14995 5.64 2.34995L4.85 3.14995C4.65 3.34995 4.34 3.34995 4.14 3.14995L3.35 2.34995C3.26 2.25995 3.13 2.20995 3 2.20995V21.7999C3.13 21.7999 3.26 21.75 3.35 21.65L4.14 20.86C4.34 20.66 4.65 20.66 4.85 20.86L5.64 21.65C5.84 21.85 6.15 21.85 6.35 21.65L7.14 20.86C7.34 20.66 7.65 20.66 7.85 20.86L8.64 21.65C8.84 21.85 9.15 21.85 9.35 21.65L10.14 20.86C10.34 20.66 10.65 20.66 10.85 20.86L11.64 21.65C11.84 21.85 12.15 21.85 12.35 21.65L13.14 20.86C13.34 20.66 13.65 20.66 13.85 20.86L14.64 21.65C14.84 21.85 15.15 21.85 15.35 21.65L16.14 20.86C16.34 20.66 16.65 20.66 16.85 20.86L17.64 21.65C17.84 21.85 18.15 21.85 18.35 21.65L19.14 20.86C19.34 20.66 19.65 20.66 19.85 20.86L20.64 21.65C20.74 21.75 20.87 21.7999 20.99 21.7999V2.20995H21ZM17 17H7C6.45 17 6 16.55 6 16C6 15.45 6.45 15 7 15H17C17.55 15 18 15.45 18 16C18 16.55 17.55 17 17 17ZM17 13H7C6.45 13 6 12.55 6 12C6 11.45 6.45 11 7 11H17C17.55 11 18 11.45 18 12C18 12.55 17.55 13 17 13ZM17 8.99995H7C6.45 8.99995 6 8.54995 6 7.99995C6 7.44995 6.45 6.99995 7 6.99995H17C17.55 6.99995 18 7.44995 18 7.99995C18 8.54995 17.55 8.99995 17 8.99995Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-receipt`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconReceipt

    ```js
    <b-new-b-icon-receipt />
    ```
</docs>


